import { Restaurant } from '@lib/types';
import { createReducer, on } from '@ngrx/store';
import produce from 'immer';
import * as AdministratorActions from '../actions/administrator.actions';

export const administratorFeatureKey = 'administrator';

export interface State {
  restaurants: Restaurant[];
  restaurant: Restaurant | null;
}

export const initialState: State = {
  restaurants: [],
  restaurant: null
};

export const reducer = createReducer(
  initialState,

  on(AdministratorActions.loadRestaurants, state => state),
  on(AdministratorActions.loadRestaurantsSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.restaurants = action.restaurants;
    });
  }),
  on(AdministratorActions.loadRestaurantsFailure, (state, action) => state),
  on(AdministratorActions.loadRestaurant, state => state),
  on(AdministratorActions.loadRestaurantSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.restaurant = action.restaurant;
    });
  }),
  on(AdministratorActions.loadRestaurantFailure, (state, action) => state),
  on(AdministratorActions.updateRestaurant, state => state),
  on(AdministratorActions.updateRestaurantSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.restaurant = action.restaurant;
    });
  }),
  on(AdministratorActions.updateRestaurantFailure, (state, action) => state),

);
